import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import interactionReducer from "./interactionSlice";
import postReducer from "./postSlice";
import commentReducer from "./commentSlice";
import categoriesReducer from "./categoriesSlice";
import tagReducer from "./tagSlice";
import settingsReducer from "./settingsSlice";
import searchReducer from "./searchSlice";
import dashboardReducer from "./dashboardSlice";
import testimonialsReducer from "./testimonialsSlice"
import contactReducer from "./contactSlice"
import aboutReducer from "./aboutSlice"
import servicesReducer from "./servicesSlice"
import appointmentReducer from "./appointmentSlice"
import customerReducer from "./customerSlice"
import childReducer from "./childSlice"
import sessionReducer from "./sessionSlice"
import expenseReducer from "./expenseSlice"
import reportReducer from "./reportSlice"
import packageReducer from "./packageSlice"
import customerPackageReducer from "./customerPackageSlice"

const store = configureStore({
  reducer: {
    user: userReducer,
    interaction: interactionReducer,
    posts: postReducer,
    comments: commentReducer,
    categories: categoriesReducer,
    tags: tagReducer,
    settings: settingsReducer,
    search: searchReducer,
    dashboard: dashboardReducer,
    testimonials:testimonialsReducer,
    contact: contactReducer,
    about:aboutReducer,
    services: servicesReducer,
    appointments:appointmentReducer,
    customers: customerReducer,
    children: childReducer,
    sessions: sessionReducer,
    expenses: expenseReducer,
    reports: reportReducer,
    packages: packageReducer,
    customerPackages: customerPackageReducer,
  },
});

export default store;
